import { configureStore } from "@reduxjs/toolkit";

import activeUserSlice from "./userSlice.js";
import sidebar from "./sidebarSlice.js";
import notificationSlice from "./notificationSlice.js";
import labelVisibilitySlice from "./labelVisibilitySlice.js";
import labelsSlice from "./labelsSlice.js";
import sessionSlice from "./sessionSlice.js";
import issuesDetectedModalSlice from "./issuesDetectedModalSlice.js";
import documentPreviewModalSlice from "./documentPreviewModalSlice.js";
import policyScoreSlice from "./policyScoreSlice.js";
import templateConflictsSlice from "./templateConflictsSlice.js";
import templateConflictModalSlice from "./templateConflictModalSlice.js";
import templateConflictsListModalSlice from "./templateConflictsListModalSlice.js";

const store = configureStore({
  reducer: {
    activeUser: activeUserSlice,
    sidebar: sidebar,
    notification: notificationSlice,
    labelVisibility: labelVisibilitySlice,
    labels: labelsSlice,
    session: sessionSlice,
    issuesDetectedModal: issuesDetectedModalSlice,
    documentPreviewModal: documentPreviewModalSlice,
    policyScore: policyScoreSlice,
    templateConflicts: templateConflictsSlice,
    templateConflictModal: templateConflictModalSlice,
    templateConflictsListModal: templateConflictsListModalSlice,
  },
});
export default store;
